import { Injector } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { StaticInjectorService } from "../services/static-injector.service";

export function SessionInitializer(configuration) {

    return function (target) {
        const route = StaticInjectorService.Injector.get(ActivatedRoute);
        if (route.snapshot.queryParams['restoreSession']==='true') {
            const _invokeBefore = configuration.invokeBefore || 'ngOnInit';
            const _actual = target.prototype[_invokeBefore];
            const _initializer = target.prototype[configuration.initializer || 'sessionInitializer'] || (() => { });
            target.prototype[_invokeBefore] = function (...args) {
                _initializer && _actual !== _initializer && _initializer.apply(this);
                _actual && _actual.apply(this, args);
            }
        }
    }
}